import React, { useState, useEffect } from 'react';
import {
  TrendingUp,
  Cpu,
  Users,
  GraduationCap,
  UploadCloud,
  FileText,
  CheckCircle,
} from 'lucide-react';

const Career = () => {

  const [jobOpenings, setJobOpenings] = useState([
    {
      id: 1,
      title: 'Network Engineer',
      description:
        'We are looking for a passionate Network Engineer with knowledge of networking concepts, routers, switches, firewalls, wireless solutions, and troubleshooting.',
      status: 'Active'
    }
  ]);

  const [formData, setFormData] = useState({
  fullName: '',
  phone: '',
  email: '',
  position: '',
  experienceLevel: 'Fresher',
  experienceYears: '',
  address: '',
  message: '',
  resume: null,
});

const handleChange = (e) => {
  const { name, value, files } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: files ? files[0] : value,
  }));
};

useEffect(() => {
  const fetchJobOpenings = async () => {
    try {
      const response = await fetch(
        'https://indyanet.com/api/get-job-openings.php'
      );

      if (!response.ok) {
        throw new Error('Failed to fetch job openings');
      }

      const result = await response.json();

      if (result.success && Array.isArray(result.job_openings)) {
        setJobOpenings(result.job_openings);
      }
    } catch (error) {
      console.error('Job openings loading error:', error);
    }
  };

  fetchJobOpenings();
}, []);

const handleResumeChange = (e) => {
  const file = e.target.files[0];

  if (!file) return;

  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  const maxSize = 5 * 1024 * 1024;

  if (!allowedTypes.includes(file.type)) {
    alert('Please upload only PDF, DOC, or DOCX files.');
    e.target.value = '';
    return;
  }

  if (file.size > maxSize) {
    alert('Resume file size must not exceed 5 MB.');
    e.target.value = '';
    return;
  }

  setFormData((prev) => ({
    ...prev,
    resume: file,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formDataToSend = new FormData();

    formDataToSend.append('fullName', formData.fullName);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('position', formData.position);
    formDataToSend.append('experienceLevel', formData.experienceLevel);
    formDataToSend.append('experienceYears', formData.experienceYears);
    formDataToSend.append('address', formData.address);
    formDataToSend.append('message', formData.message);
    formDataToSend.append('resume', formData.resume);

    const response = await fetch(
  'https://indyanet.com/api/submit-career.php',
  {
    method: 'POST',
    body: formDataToSend,
  }
);

// Read the raw response first
const responseText = await response.text();

console.log("Server Response:");
console.log(responseText);

// Try to convert to JSON
let result;

try {
  result = JSON.parse(responseText);
} catch (e) {
  alert("Server returned an invalid response.\n\nCheck the browser console.");
  return;
}

if (result.success) {

      alert(
        `Application submitted successfully!\nApplication ID: ${result.application_id}`
      );

      setFormData({
        fullName: '',
        phone: '',
        email: '',
        address: '',
        position: '',
        experienceLevel: 'Fresher',
        experienceYears: '',
        message: '',
        resume: null,
      });

      const resumeInput = document.getElementById('resume');

      if (resumeInput) {
        resumeInput.value = '';
      }

    } else {
      alert(
        result.message ||
        'Failed to submit application. Please try again.'
      );
    }

  } catch (error) {
  console.error("Career application error:", error);

  alert(error.message);
}
};

  const scrollToForm = () => {
    const section = document.getElementById('career-form');

    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  const applyForPosition = (position) => {
  setFormData((prev) => ({
    ...prev,
    position,
  }));

  setTimeout(() => {
    const section = document.getElementById('career-form');

    if (section) {
      section.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, 100);
};
  return (
    <div className="bg-gray-50">

      {/* Hero Section */}

      <section className="bg-gradient-to-r from-red-600 to-red-700 text-white py-20">

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">

          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Build Your Career with IndyaNet
          </h1>

          <p className="max-w-3xl mx-auto text-red-100 text-lg leading-8">

            Join our growing team of networking professionals and technology experts.
            Whether you're applying for an open position or would like to be considered
            for future opportunities, we'd love to hear from you.

          </p>

          <button
            onClick={scrollToForm}
            className="mt-10 bg-white text-red-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition duration-300 shadow-lg"
          >
            Apply Today
          </button>

        </div>

      </section>

      {/* Why Join IndyaNet */}

<section className="py-20 bg-white">

  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <div className="text-center mb-14">

      <h2 className="text-4xl font-bold text-gray-900 mb-4">
        Why Join IndyaNet?
      </h2>

      <p className="text-gray-600 max-w-3xl mx-auto leading-8">
        Become a part of a passionate team delivering innovative networking,
        cloud, and enterprise connectivity solutions while building a rewarding
        career in the technology industry.
      </p>

    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

      {/* Card 1 */}

      <div className="bg-gray-50 rounded-xl shadow-md p-8 text-center hover:shadow-xl transition duration-300">

        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <TrendingUp className="text-red-600" size={32} />
        </div>

        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          Career Growth
        </h3>

        <p className="text-gray-600 leading-7">
          Grow your career through exciting projects, continuous learning,
          and opportunities to take on new challenges.
        </p>

      </div>

      {/* Card 2 */}

      <div className="bg-gray-50 rounded-xl shadow-md p-8 text-center hover:shadow-xl transition duration-300">

        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Cpu className="text-red-600" size={32} />
        </div>

        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          Innovative Technologies
        </h3>

        <p className="text-gray-600 leading-7">
          Work with enterprise networking, cloud solutions,
          security technologies, and modern IT infrastructure.
        </p>

      </div>

      {/* Card 3 */}

      <div className="bg-gray-50 rounded-xl shadow-md p-8 text-center hover:shadow-xl transition duration-300">

        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Users className="text-red-600" size={32} />
        </div>

        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          Collaborative Culture
        </h3>

        <p className="text-gray-600 leading-7">
          Work alongside experienced professionals in an
          environment that values teamwork, innovation,
          and customer success.
        </p>

      </div>

      {/* Card 4 */}

      <div className="bg-gray-50 rounded-xl shadow-md p-8 text-center hover:shadow-xl transition duration-300">

        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <GraduationCap className="text-red-600" size={32} />
        </div>

        <h3 className="text-xl font-semibold text-gray-900 mb-3">
          Continuous Learning
        </h3>

        <p className="text-gray-600 leading-7">
          Enhance your skills through practical experience,
          training opportunities, and exposure to
          real-world enterprise projects.
        </p>

      </div>

    </div>

  </div>

</section>

{/* Life at IndyaNet */}

<section className="py-20 bg-white">

  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

    <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-10 md:p-14 text-white shadow-xl">

      <h2 className="text-3xl md:text-4xl font-bold mb-6">
        Build the Future with IndyaNet
      </h2>

      <p className="text-gray-300 leading-8 text-lg">
        At <span className="font-semibold text-white">INDYANET</span>, we're not just
        building technology—we're transforming the way people and businesses
        connect every day. We believe in giving our team the freedom to think,
        take ownership, and create meaningful impact.
      </p>

      <p className="text-gray-300 leading-8 text-lg mt-5">
        If you're curious, driven, and eager to learn, you'll work alongside
        experienced professionals on real-world networking and technology
        solutions while growing your skills in a collaborative environment.
      </p>

    </div>

  </div>

</section>

{/* Current Opportunities */}

<section className="py-20 bg-gray-50">

  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <div className="text-center mb-14">

      <h2 className="text-4xl font-bold text-gray-900 mb-4">
        Current Opportunities
      </h2>

      <p className="text-gray-600 max-w-3xl mx-auto leading-8">
        We're currently hiring fresh graduates who are passionate about technology and eager to start their careers with IndyaNet.
      </p>

    </div>

    {/* Hiring Notice */}

<div className="max-w-4xl mx-auto mb-12">

  <div className="bg-gradient-to-r from-red-600 to-red-700 rounded-2xl shadow-xl p-8 text-center">

    <span className="inline-block bg-white text-red-600 text-sm font-bold px-4 py-2 rounded-full uppercase tracking-wide mb-4">
      Now Hiring
    </span>

    <h2 className="text-4xl font-extrabold text-white uppercase tracking-wide">
  🚀 WE'RE HIRING
</h2>

<p className="text-red-100 text-lg leading-8 max-w-2xl mx-auto">
  Explore our current opportunities and join the team.
Whether you're a fresher starting your career or an experienced
professional looking for your next opportunity, we're looking for
passionate people to grow with us. Join
  <strong className="text-white"> IndyaNet</strong> and grow with
  real-world technology and networking projects.
</p>

  </div>

</div>

    <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

  {/* Open Positions */}

  {jobOpenings.filter((job) => job.status === 'Active').length > 0 ? (

    jobOpenings
      .filter((job) => job.status === 'Active')
      .map((job) => (
    
    <div
  key={job.id}
  className="border rounded-xl p-6 hover:shadow-md transition"
>

  <h3 className="text-2xl font-semibold text-red-600 mb-4">
    🌐 {job.title}
  </h3>

  <div className="space-y-2 mb-5 text-sm text-gray-600">

    {job.department && (
      <p>
        <span className="font-semibold text-gray-800">
          Department:
        </span>{' '}
        {job.department}
      </p>
    )}

    {job.location && (
      <p>
        <span className="font-semibold text-gray-800">
          Location:
        </span>{' '}
        {job.location}
      </p>
    )}

    {job.employment_type && (
      <p>
        <span className="font-semibold text-gray-800">
          Employment:
        </span>{' '}
        {job.employment_type}
      </p>
    )}

    {job.experience && (
      <p>
        <span className="font-semibold text-gray-800">
          Experience:
        </span>{' '}
        {job.experience}
      </p>
    )}

  </div>

  <p className="text-gray-600 leading-7 mb-5">
  {job.description}
</p>

{job.responsibilities && (
  <div className="mb-5">

    <h4 className="font-semibold text-gray-800 mb-2">
      Responsibilities
    </h4>

    <p className="text-gray-600 leading-7 whitespace-pre-line">
      {job.responsibilities}
    </p>

  </div>
)}

{job.skills && (
  <div className="mb-5">

    <h4 className="font-semibold text-gray-800 mb-2">
      Required Skills
    </h4>

    <p className="text-gray-600 leading-7 whitespace-pre-line">
      {job.skills}
    </p>

  </div>
)}

<div className="flex flex-wrap items-center gap-4">

  <span className="inline-block bg-green-100 text-green-700 text-sm px-4 py-2 rounded-full font-medium">
    Hiring Now
  </span>

  <button
    type="button"
    onClick={() => applyForPosition(job.title)}
    className="bg-red-600 text-white px-5 py-2 rounded-lg font-semibold hover:bg-red-700 transition duration-300"
  >
    Apply for this Position
  </button>

</div>

</div>
      ))
  ) : (

    <div className="md:col-span-2 lg:col-span-2 border border-dashed border-gray-300 rounded-xl p-8 text-center">

      <div className="text-5xl mb-4">
        💼
      </div>

      <h3 className="text-2xl font-semibold text-gray-900 mb-3">
        No Current Openings Available
      </h3>

      <p className="text-gray-600 leading-7">
        We don't have any active job openings at the moment.
        However, you can still submit a general application and our
        HR team may contact you when a suitable opportunity becomes available.
      </p>

    </div>

  )}

{/* Future Opportunities */}

        <div className="border rounded-xl p-6 hover:shadow-md transition">

  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
    Looking for Another Role?
  </h3>

  <p className="text-gray-600 leading-7 mb-5">
    Don't see the position you're looking for?
    You can still submit your application.
    Our team will review your profile and contact you if a suitable
    opportunity becomes available.
  </p>

  <button
    type="button"
    onClick={() => applyForPosition('Other / Future Opportunities')}
    className="bg-gray-900 text-white px-5 py-2 rounded-lg font-semibold hover:bg-gray-800 transition duration-300"
  >
    Submit General Application
  </button>

</div>

      </div>

    </div>

  </div>

</section>

{/* Career Application Form */}

<section className="py-20 bg-white">

  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

    <div
      id="career-form"
      className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 md:p-12"
    >

      <div className="text-center mb-10">

        <h2 className="text-4xl font-bold text-gray-900 mb-4">
          Career Application Form
        </h2>

        <p className="text-gray-600 leading-8 max-w-3xl mx-auto">
          Ready to join our team? Complete the application below and upload your
          resume. Our team will review your application and contact you if a
          suitable opportunity becomes available.
        </p>

      </div>

      <form onSubmit={handleSubmit}>
        {/* Personal Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* Full Name */}

          <div>

            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Full Name <span className="text-red-600">*</span>
            </label>

            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500"
            />

          </div>

          {/* Phone */}

          <div>

            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Phone Number <span className="text-red-600">*</span>
            </label>

            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter your phone number"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500"
            />

          </div>

          {/* Email */}

          <div>

            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Email Address <span className="text-red-600">*</span>
            </label>

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email address"
              className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500"
            />

          </div>

          {/* Position */}

<div>

  <label className="block text-sm font-semibold text-gray-700 mb-2">
    Position Applying For <span className="text-red-600">*</span>
  </label>

  <select
    name="position"
    value={formData.position}
    onChange={handleChange}
    required
    className="w-full border border-gray-300 rounded-lg px-4 py-3 bg-white focus:outline-none focus:ring-2 focus:ring-red-500"
  >

    <option value="">
      Select a position
    </option>

    {jobOpenings.filter((job) => job.status === 'Active').length > 0 ? (

  jobOpenings
    .filter((job) => job.status === 'Active')
    .map((job) => (

      <option
        key={job.id}
        value={job.title}
      >
        {job.title}
      </option>

    ))

) : (

  <option
    value=""
    disabled
  >
    No current openings available
  </option>

)}

    <option value="Other / Future Opportunities">
      Other / Future Opportunities
    </option>

  </select>

</div>

            <div>

              <label className="block text-sm font-semibold text-gray-700 mb-2">
              Experience Level <span className="text-red-600">*</span>
              </label>

              <select
                  name="experienceLevel"
                  value={formData.experienceLevel}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
              >

              <option value="Fresher">Fresher</option>
              <option value="Experienced">Experienced</option>

              </select>

            </div>


            {formData.experienceLevel === 'Experienced' && (

            <div>

              <label className="block text-sm font-semibold text-gray-700 mb-2">
              Years of Experience
              <span className="text-red-600">*</span>
              </label>

              <select
                  name="experienceYears"
                  value={formData.experienceYears}
                  onChange={handleChange}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3"
              >

              <option value="">Select</option>
              <option value="0-1 Year">0-1 Year</option>

              </select>

            </div>

)}


        </div>

        {/* Address */}
        <div className="mt-6">

          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Current Address <span className="text-red-600">*</span>
          </label>

          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
            rows="3"
            placeholder="Enter your current address"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
          />

        </div>

        {/* Message */}
        <div className="mt-6">

          <div className="flex items-center justify-between mb-2">

            <label className="block text-sm font-semibold text-gray-700">
              Message
            </label>

            <span className="text-sm text-gray-500">
              {formData.message.length} / 2500 Characters
            </span>

          </div>

          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            maxLength={2500}
            rows="7"
            placeholder="Tell us about yourself, your skills, achievements, career interests, or why you'd like to join IndyaNet."
            className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
          />

          <p className="text-sm text-gray-500 mt-2">
            Maximum 2500 characters.
          </p>

        </div>

        {/* Resume Upload */}
        <div className="mt-8">

          <label className="block text-sm font-semibold text-gray-700 mb-3">
            Upload Resume <span className="text-red-600">*</span>
          </label>

          <label
            htmlFor="resume"
            className="block border-2 border-dashed border-gray-300 rounded-xl p-8 text-center cursor-pointer hover:border-red-500 hover:bg-red-50 transition duration-300"
          >

            {!formData.resume ? (

              <div>

                <UploadCloud
                  className="mx-auto text-red-600 mb-4"
                  size={48}
                />

                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  Drag & Drop Your Resume Here
                </h3>

                <p className="text-gray-500 mb-3">
                  or click to browse files
                </p>

                <span className="inline-block bg-red-600 text-white px-6 py-2 rounded-lg font-semibold">
                  Browse Files
                </span>

                <p className="text-sm text-gray-500 mt-5">
                  Supported Formats: PDF, DOC, DOCX
                </p>

                <p className="text-sm text-gray-500 mt-1">
                  Maximum File Size: 5 MB
                </p>

              </div>

            ) : (

              <div>

                <CheckCircle
                  className="mx-auto text-green-500 mb-4"
                  size={48}
                />

                <FileText
                  className="mx-auto text-red-600 mb-3"
                  size={40}
                />

                <h3 className="text-lg font-semibold text-gray-900 break-all">
                  {formData.resume.name}
                </h3>

                <p className="text-gray-500 mt-2">
                  {(formData.resume.size / (1024 * 1024)).toFixed(2)} MB
                </p>

                <p className="text-sm text-green-600 font-semibold mt-3">
                  Resume selected successfully
                </p>

                <p className="text-sm text-gray-500 mt-2">
                  Click here to choose another file
                </p>

              </div>

            )}

            <input
              id="resume"
              type="file"
              name="resume"
              accept=".pdf,.doc,.docx"
              onChange={handleResumeChange}
              required
              className="hidden"
            />

          </label>

        </div>

        {/* Submit Button */}
        <div className="mt-10">

          <button
            type="submit"
            className="w-full bg-red-600 text-white py-4 rounded-lg font-semibold text-lg hover:bg-red-700 transition duration-300 shadow-lg"
          >
            Submit Application
          </button>

        </div>

      </form>

    </div>

  </div>

</section>


       {/* HR Contact Section */}

<section className="py-12 bg-gray-50 border-t border-gray-200">

  <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

    <div className="bg-white rounded-2xl shadow-md border border-gray-200 p-8 text-center">

      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        Need Assistance?
      </h2>

      <p className="text-gray-600 leading-8 max-w-3xl mx-auto">
        If you have any questions regarding career opportunities,
        the recruitment process, or your application, our HR team
        will be happy to assist you.
      </p>

      <p className="mt-6 text-lg">

        <span className="font-semibold text-gray-900">
          HR Email:
        </span>

        <a
          href="mailto:hr@indyanet.com"
          className="ml-2 text-red-600 font-semibold hover:underline"
        >
          hr@indyanet.com
        </a>

      </p>

      <p className="text-sm text-gray-500 mt-3">
        We aim to respond to all career-related enquiries as soon as possible.
      </p>

    </div>

  </div>

</section>
     



  </div>
  );
};

export default Career;